import type { CallCategory } from "@expert/shared-types";

import { getRootDispatcher } from "@/analytics";

export function emitPacingTargetUpdated(params: {
    previousCallCategory: CallCategory;
    newCallCategory: CallCategory;
    previousTargetSeconds: number;
    newTargetSeconds: number;
    elapsedAtUpdateSeconds: number;
}) {
    void getRootDispatcher().dispatchBusinessEvent("PacingTargetUpdated", params);
}

export function emitPacingThresholdCrossed(params: {
    threshold: "approaching" | "exceeded";
    elapsedSeconds: number;
    targetSeconds: number;
    gaiaCallCategory: CallCategory | undefined;
}) {
    void getRootDispatcher().dispatchBusinessEvent("PacingThresholdCrossed", params);
}
